import { UUID } from '@cmg/common';

import { useCheckWallCrossAccess } from '../../../../../common/util/check-access/useCheckWallCrossAccess';
import routeFactory from '../../../../../common/util/routeFactory';
import { ReactRouterDomainNavTabProps } from '../../../../../design-system/react-router/ReactRouterDomainNavTab';

type Props = {
  offeringId: UUID | undefined;
  isWallCrossEnabled?: boolean;
  isDiscarded: boolean;
};

export const useWallCrossRoute = ({
  offeringId,
  isWallCrossEnabled,
  isDiscarded,
}: Props): ReactRouterDomainNavTabProps | undefined => {
  const { canRead } = useCheckWallCrossAccess();
  if (!canRead) return undefined;

  if (!offeringId) return undefined;

  if (isDiscarded) return undefined;

  if (!isWallCrossEnabled) return undefined;

  const href = routeFactory.wallCross.getUrlPath({ offeringId });

  return {
    href: href,
    label: 'Wall Cross',
  };
};
